module.exports = __webpack_public_path__ + "img/kv-title.1fa1084e.png";